// src/components/ForgotPassword.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { requestPasswordReset, clearResetPasswordError } from '../contents/redux/actions/authActions';
import styles from './utilities/cssmodules/CreatePassword.module.css';
import { toast } from 'react-toastify';

import lccLogo from "../../src/images/lcc_logo.png";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [email, setEmail] = useState('');
  const [localError, setLocalError] = useState('');
  const [loading, setLoading] = useState(false);

  const { forgotPasswordError, forgotPasswordSuccess } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    dispatch(clearResetPasswordError());
  }, [dispatch]);

  // Combine errors
  const displayError = localError || forgotPasswordError;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setLocalError('Please enter your email address.');
      return;
    }

    // Basic email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setLocalError('Please enter a valid email address.');
      return;
    }

    setLocalError('');
    setLoading(true);

    try {
      await dispatch(requestPasswordReset({ email }, navigate));
      toast.success('If this email exists, a reset link has been sent.');
    } catch (error) {
      // Handled in action via toast
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.create_password_wrapper}>
      <div className={styles.action_component_header}>
        <div className={styles.action_component_header_logo}>
          <img src={lccLogo} alt="lcc logo" className={styles.logo_1} />
        </div>
        <div className={styles.action_component_header_text}>
          Liberia Chamber of Commerce
        </div>
      </div>

      <p className={styles.description}>
        Forgot your password? Enter your email below and we’ll send you a secure
        link to reset it.
      </p>


      <form onSubmit={handleSubmit} className={styles.create_password_form}>
        <div className={styles.field_group}>
          <label htmlFor="email">Email address</label>
          <input
            id="email"
            type="email"
            placeholder="Enter your account email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <button type="submit" disabled={loading} className={styles.submit_button}>
          {loading ? 'Getting...' : 'Get reset link'}
        </button>

        {displayError && <p className={styles.error_message}>{displayError}</p>}
        {forgotPasswordSuccess && (
            <p className={styles.success_message}>
            Please check your email for the password reset link.
            </p>
        )}
      </form>
    </div>
  );
};

export default ForgotPassword;
